
    var riot = require('riot')
    //src: starling/src/tags/navigation-switcher.html
riot.tag2('navigation-switcher',
  '<button data-tip="{\'Navigation mode\': !menuOpen}" data-tip-align="{top: !menuOpen}" class="zoom-button" onclick="{toggleMenuOpen}"> <svg class="zoom-button_icon"> <use xlink:href="{getActiveIcon()}"></use> </svg> </button> <div class=" floating-menu floating-menu--top floating-menu--right {floating-menu--hidden: !menuOpen} "> <ul class="floating-menu_list"> <li class="floating-menu_item {floating-menu_item--active: getMode() === \'trackpad\'}" onclick="{setTrackpad}"> <svg class="floating-menu_icon"> <use xlink:href="#trackpad-icon"></use> </svg> <div class="floating-menu_label floating-menu_label--narrow"> <div class="floating-menu_label_title floating-menu_label_title--bold"> Touchpad navigation </div> <div class="floating-menu_label_description"> Scroll to move / pinch to zoom </div> </div> </li> <li class="floating-menu_divider"></li> <li class="floating-menu_item {floating-menu_item--active: getMode() === \'mouse\'}" onclick="{setMouse}"> <svg class="floating-menu_icon"> <use xlink:href="#mouse-icon"></use> </svg> <div class="floating-menu_label floating-menu_label--narrow"> <div class="floating-menu_label_title floating-menu_label_title--bold"> Mouse navigation </div> <div class="floating-menu_label_description"> Drag to move / mouse wheel to zoom </div> </div> </li> </ul> </div>',
  '',
  'hide="{pageSettings.hideMapZoomControls}" class="zoom-tools hideWhenPresenting" style="margin-right: 0; right: 250px;"', function(opts) {
'use strict';

var _this = this;

var _opts = opts,
    canvas = _opts.canvas;

canvas.navigationSwitcher = this;

this.toggleMenuOpen = function (e) {
  _this.menuOpen = !_this.menuOpen;
  _this.update();
};

this.hideMenu = function () {
  _this.menuOpen = false;
  _this.update();
};

this.showMenu = function () {
  _this.menuOpen = true;
  _this.update();
};

this.getActiveIcon = function () {
  var mode = _this.getMode();
  if (mode === 'trackpad') {
    return '#trackpad-icon';
  } else {
    return '#mouse-icon';
  }
};

this.getMode = function () {
  var pointer = canvas.pointer || localStorage.getItem('pointer-type') || 'mouse';
  if (pointer === 'trackpad') {
    return 'trackpad';
  } else {
    return 'mouse';
  }
};

this.setTrackpad = function () {
  var userSettingsTag = canvas.userSettingsTag;

  localStorage.setItem('pointer-type', 'trackpad');
  canvas.pointer = 'trackpad';
  userSettingsTag && userSettingsTag.update();
  _this.update();
};

this.setMouse = function () {
  var userSettingsTag = canvas.userSettingsTag;

  localStorage.setItem('pointer-type', 'mouse');
  canvas.pointer = 'mouse';
  userSettingsTag && userSettingsTag.update();
  _this.update();
};
});

    
  if (module.hot) {
    module.hot.accept()
    if (module.hot.data) {
      riot.reload('navigation-switcher')
    }
  }
  


//////////////////
// WEBPACK FOOTER
// ./starling/src/tags/navigation-switcher.html
// module id = 807
// module chunks = 0